import React, {Component} from 'react';
import {Table, Button, Pagination, Icon} from 'semantic-ui-react';
import produce from 'immer';
import {PortalWithState} from 'react-portal';
import {Spring} from 'react-spring/renderprops';

import RequiresRole, {ROLES} from '../security/RequiresRole';
import {ModalWrapper} from '../modal/ModalWrapper';
import {SerialNumberDetail} from '../dashboard/SerialNumberDetail';

class SerialTable extends Component {
  state = {
    selectedResult: undefined,
    pageInfo: undefined,
    loading: false,
    activePage: 1,
  };

  _mutate = (draftFn, cb) => {
    this.setState(produce(draftFn), cb);
  };

  _showDetail = selectedResult => {
    this._openPortal();
    this.setState({selectedResult});
  };

  _renderDetailModal = () => {
    const {selectedResult} = this.state;

    return (
      <Spring from={{right: '-100%'}} to={{right: '0%'}}>
        {styles => (
          <ModalWrapper style={styles}>
            <SerialNumberDetail
              key={selectedResult}
              sysRowId={selectedResult}
              close={this._closePortal}
            />
          </ModalWrapper>
        )}
      </Spring>
    );
  };

  _renderRow = result => {
    return (
      <Table.Row key={result.sysRowID}>
        <Table.Cell>
          <Button
            className="link"
            icon
            onClick={() => this._showDetail(result.sysRowID)}
          >
            {result.serialNumber}
          </Button>
        </Table.Cell>
        <RequiresRole roles={[ROLES.CUSTOMER_ADMIN]}>
          <Table.Cell>{result.partNum}</Table.Cell>
        </RequiresRole>
      </Table.Row>
    );
  };

  render() {
    const {serialNumbers} = this.props;
    const {activePage} = this.state;
    const pageSize = 20;

    return (
      <PortalWithState closeOnEsc>
        {({openPortal, closePortal, portal}) => {
          this._closePortal = closePortal;
          this._openPortal = openPortal;
          return (
            <React.Fragment>
              <Table basic="very" unstackable striped>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Serial Number</Table.HeaderCell>
                    <RequiresRole roles={[ROLES.CUSTOMER_ADMIN]}>
                      <Table.HeaderCell>Part Number</Table.HeaderCell>
                    </RequiresRole>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {serialNumbers
                    .slice((activePage - 1) * pageSize, activePage * pageSize)
                    .map(searchResult => this._renderRow(searchResult))}
                </Table.Body>
              </Table>
              {portal(this._renderDetailModal())}
              <Pagination
                defaultActivePage={1}
                onPageChange={async (e, paginationInfo) => {
                  this.setState({activePage: paginationInfo.activePage});
                }}
                ellipsisItem={{
                  content: <Icon name="ellipsis horizontal" />,
                  icon: true,
                }}
                firstItem={{
                  content: <Icon name="angle double left" />,
                  icon: true,
                }}
                lastItem={{
                  content: <Icon name="angle double right" />,
                  icon: true,
                }}
                prevItem={{content: <Icon name="angle left" />, icon: true}}
                nextItem={{
                  content: <Icon name="angle right" />,
                  icon: true,
                }}
                totalPages={Math.ceil(serialNumbers.length / pageSize)}
              />
            </React.Fragment>
          );
        }}
      </PortalWithState>
    );
  }
}

export default SerialTable;
